import cursorPaginationModule from "../cursorPaginationModule";
import { cursorPaginationConstants } from "core-utilities";

cursorPaginationModule.constant("cursorPaginationConstants", cursorPaginationConstants);
export default cursorPaginationConstants;